export default {
    workOrder_customerSelector_title: "Seleccionar Cliente",
    workOrder_customerSelector_customer: "Cliente",
    workOrder_customerSelector_create_new_customer: "Crear Nuevo Cliente",
    workOrder_customerSelector_contact: "Contacto",
    workOrder_customerSelector_create_new_contact: "Crear Nuevo Contacto",
    workOrder_customerSelector_location: "Ubicación",
    workOrder_customerSelector_create_new_location: "Crear Nueva Ubicación",
};